export type ApiConfig = {
    domain: string,
    baseUrl: string,
    frontendAssetsUrl: string,
};

const domain = ((window as any).buggyFitApiBaseUrl as string || 'http://localhost:8000');

const config: ApiConfig = {
    domain: domain,
    baseUrl: domain + '/v1',
    frontendAssetsUrl: domain + '/frontend-assets',
};

export default config;
